<!--
老师点评分析
-->
<template>
    <or-layout>
        <a-row :gutter="[16, 16]" type="flex" justify="space-between">
            <a-col :span="5">
            </a-col>
            <a-col>
                <a-form layout="inline">
                    <a-form-item>
                        <a-select v-model="searchFrom.campus_id" placeholder="校区" style="width: 150px;" allow-clear>
                            <a-select-option v-for="item in campusList" :key="item.id" :value="item.id">{{ item.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item>
                        <a-select v-model="searchFrom.grade_id" placeholder="年级" style="width: 220px;" allow-clear>
                            <a-select-option v-for="(item) in gradeList" :key="item.id" :value="item.id">{{ item.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item>
                        <a-range-picker :show-time="{ format: 'HH:mm' }" format="YYYY-MM-DD HH:mm"
                        :placeholder="['开始时间', '结束时间']" @change="onChange" />
                </a-form-item>
                <!-- <a-form-item>
                        <a-select v-model="searchFrom.mission_type" placeholder="任务类型" style="width: 220px;" allow-clear>
                            <a-select-option v-for="(item) in gradeList" :key="item.id" :value="item.id">{{item.name}}
                                </a-select-option>
                            </a-select>
                        </a-form-item> -->
                    <a-form-item>
                        <a-select v-model="searchFrom.opening" placeholder="开班状态" allow-clear style="width: 120px;">
                            <a-select-option :key="0" :value="0">未开班</a-select-option>
                            <a-select-option :key="1" :value="1">已开班</a-select-option>
                            <a-select-option :key="2" :value="2">已结班</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item>
                        <a-select v-model="searchFrom.semester_name" placeholder="季度" allow-clear style="width: 80px;">
                            <a-select-option :key="-1" value="">全部</a-select-option>
                            <a-select-option :key="0" value="寒假">寒假</a-select-option>
                            <a-select-option :key="1" value="春季">春季</a-select-option>
                            <a-select-option :key="2" value="暑假">暑假</a-select-option>
                            <a-select-option :key="3" value="秋季">秋季</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item>
                        <a-select v-model="searchFrom.year_name" placeholder="年度" allow-clear style="width: 90px;">
                            <a-select-option :key="-1" value="">全部</a-select-option>
                            <a-select-option :key="3" value="2023">2023年</a-select-option>
                            <a-select-option :key="2" value="2022">2022年</a-select-option>
                            <a-select-option :key="0" value="2021">2021年</a-select-option>
                            <a-select-option :key="1" value="2020">2020年</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item>
                        <a-select v-model="searchFrom.user_type" placeholder="老师/班主任" allow-clear style="width: 120px;">
                            <a-select-option :key="0" :value="0">老师</a-select-option>
                            <a-select-option :key="1" :value="1">班主任</a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item>
                        <a-select v-model="searchFrom.type" placeholder="题型" allow-clear style="width: 120px;">
                            <a-select-option :key="0" value="ANSWER">解答题</a-select-option>
                            <a-select-option :key="1" value="VIDEO">口述题</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item>
                        <a-input placeholder="老师姓名" v-model="searchFrom.keyword" @keyup.enter="tableSearch"></a-input>
                    </a-form-item>
                    <a-form-item>
                        <a-input placeholder="学生姓名" v-model="searchFrom.studentkeyword"
                            @keyup.enter="tableSearch"></a-input>
                    </a-form-item>
                    <a-form-item>
                        <a-button type="primary" htmlType="submit" icon="search" @click="tableSearch"></a-button>
                    </a-form-item>
                </a-form>
            </a-col>
        </a-row>
        <a-divider></a-divider>
        <div>
            <a-tabs default-active-key="1">
                <a-tab-pane key="1" tab="表格">
                    <a-table :dataSource="tabledata" :rowKey="item => item.id" :pagination="pageinfo" :loading="loading"
                        @change="onPaginationChange" bordered>
                        <a-table-column key="title" title="题目信息" width="400px">
                            <template slot-scope="item">
                                <span v-html="item.title"></span>
                            </template>
                        </a-table-column>
                        <a-table-column key="nickname" title="老师名字" data-index="nickname" />
                        <a-table-column key="username" title="学生名字" data-index="username" />

                        <a-table-column key="comment" title="老师批改" width="200px">
                            <template slot-scope="item">
                                <audio style="width: 160px" :src="item.audio_path" v-if="item.audio_path" controls />
                                <span v-html="item.comment"></span>
                                <!--  <span v-html="item.comment"></span> -->
                            </template>
                        </a-table-column>
                        <a-table-column key="user_answer" title="学生答案" width="200px">
                            <template slot-scope="item">
                                <img style="cursor: zoom-in" :preview="item.id"
                                    :large="item.user_answer + '?x-oss-process=image/resize,w_800/auto-orient,1'"
                                    :preview-text="'学生回答'"
                                    :src="item.user_answer + '?x-oss-process=image/resize,w_100,h_80/auto-orient,1'"
                                    v-if="item.typestr == 'ANSWER'" />
                                <a-button type="primary" @click="video_path = item.user_answer; video_visible = true;"
                                    v-if="item.typestr == 'VIDEO'">播放</a-button>
                                <!-- <a-button type="primary" @click="addLectureVideo(item)" :disabled="item.is_hot_video!=0" style="margin-left: 5px;" v-if="item.typestr=='VIDEO'" >{{item.is_hot_video==0?"推荐":"已推荐"}}</a-button> -->
                                <!-- <img  v-if="item.typestr=='ANSWER'" :src="item.user_answer" width="100px;"/> -->
                            </template>
                        </a-table-column>
                        <a-table-column key="correct" title="对错" :width="80">
                            <template slot-scope="item">
                                <span v-if="item.correct == 0">未批改</span>
                                <a-icon v-if="item.isright == 0 && item.correct == 1" type="close"
                                    :style="{ fontSize: '22px', color: 'red' }" />
                                <a-icon v-if="item.isright == 1 && item.correct == 1" type="check"
                                    :style="{ fontSize: '22px', color: 'green' }" />
                            </template>
                        </a-table-column>

                        <a-table-column key="pg_time" title="批改时间">
                            <template slot-scope="item">
                                <span>
                                    {{ moment(item.pg_time * 1000).format('lll') }}
                                </span>
                            </template>
                        </a-table-column>
                    </a-table>
                    <a-modal :visible="video_visible" title="视频播放" @ok="video_visible = false" :destroyOnClose="true"
                        :footer="null" @cancel="video_visible = false">
                        <video :src="video_path" style="max-width: 100%;max-height: 300px;" autoplay controls />
                        <div style="text-align: right;margin-top: 1rem;">
                            <a-button type="primary" @click="video_visible = false">关闭</a-button>
                        </div>
                    </a-modal>
                </a-tab-pane>

            <a-tab-pane key="2" tab="图表" force-render>
                <!--    <v-chart :forceFit="true" :height="400" :data="piedata" :scale="scale">
                        <v-tooltip :showTitle="false" dataKey="item*percent" />
                        <v-axis />
                        <v-legend dataKey="item" />
                            <v-pie position="percent" color="item" :v-style="pieStyle" :label="labelConfig" />
                            <v-coord type="theta" />
                    </v-chart> -->

                <!--  <a-divider></a-divider>
                    <v-chart :forceFit="true" :padding="padding" :height="heightx" :data="chartdata">
                        <v-coord type="rect" direction="LB" />
                        <v-tooltip />
                        <v-legend />
                        <v-axis dataKey="label" label="nickname" />
                            <v-axis dataKey="label" position="right" />
                            <v-stack-bar position="nickname*value" color="type" />
                        </v-chart> -->
                </a-tab-pane>
            </a-tabs>



        </div>


    </or-layout>
</template>

<script>
import AFormItem from "ant-design-vue/es/form/FormItem";
import moment from "moment";
//  const DataSet = require('@antv/data-set');

export default {
    components: {
        AFormItem
    },
    data() {
        return {
            tabledata: [],
            pageinfo: {
                total: 1,
                current: 1,
                pageSize: 20
            },
            padding: [10, 80, 50, 100],
            loading: false,
            courseList: [],
            searchFrom: {
                keyword: undefined,
                grade_id: undefined,
                campus_id: undefined,
                studentkeyword: undefined,
                type: 'ANSWER',
                opening: 1,
                start_time: Number,
                end_time: Number,
                user_type: 0,
                semester_name: '寒假',
                year_name: '2021'
            },
            video_path: undefined,
            video_visible: false,
            dataviser: [],
            label: {
                offset: 12
            },
            campusList: [],
            gradeList: [],
            campuscount: [],
        };
    },
    mounted() {
        this.getCampusList();
        this.getGradeList();
    },
    computed: {
        /* chartdata() {
             //  let me = this 
             const sourceData = [];
             this.tabledata.forEach(row => {
                   row['不参测人数'] = Number(row['nocc']);
                    row['参测人数'] = Number(row['statisticcount']);
                 sourceData.push(row);
             });
             const dv = new DataSet.View().source(sourceData);
             dv.transform({
                 type: 'fold',
                 fields: ['参测人数', '不参测人数'],
                 key: 'type',
                 value: 'value',
                 retains: ['nickname'],
             });
             const dataviser = dv.rows;
             return dataviser;
         },

        
         heightx() {
             return this.tabledata.length * 50;
         } */

    },

    methods: {
        moment,
        getGradeList() {
            this.$axios
                .post("/api/BasicGrade/index")
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                    } else {
                        this.gradeList = res.data.data;
                    }
                })
                .catch(err => {
                    console.error(err);
                });
        },
        onChange(value, dateString) {
            dateString,
                this.searchFrom.start_time = Number(value[0] / 1000);
            this.searchFrom.end_time = Number(value[1] / 1000);
            //this.searchForm.end_time=Number(value[1]/1000);
            // console.log('Selected Time: ', value[1]);
            // console.log('Formatted Selected Time: ', dateString[0]);
        },

        getCourseList() {
            this.$axios
                .post("/api/BasicCourse/index", {
                    pageinfo: {
                        pageSize: 9999
                    }
                })
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                    } else {
                        this.courseList = res.data.data;
                    }
                })
                .catch(err => {
                    console.error(err);
                });
        },
        getCampusList() {
            this.$axios
                .post("/api/admin/getmycampuslist")
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                    } else {
                        this.campusList = res.data;
                        this.tableSearch();
                        // this.getCourseList();
                    }
                })
                .catch(err => {
                    console.error(err);
                });
        },
        changeCampus(e) {
            this.searchForm.campus_id = e;
        },
        onPaginationChange(item) {
            this.pageinfo.current = item.current;
            this.getTableList(this.searchFrom);
        },
        tableSearch() {
            this.pageinfo.current = 1;
            this.getTableList(this.searchFrom);
        },
        getTableList(data) {
            this.loading = true;
            this.$axios
                .post("/api/AnalyseInfo/getteachercomment", {
                    data,
                    pageinfo: this.pageinfo
                })
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                    } else {

                        this.tabledata = res.data.data;
                        this.pageinfo = res.data.pageinfo;

                    }
                })
                .catch(err => {
                    console.error(err);
                }).finally(() => {
                    this.loading = false;
                })
        }
    }
};
</script>
<style>
.active_btn {
    margin-left: 5px;
}
</style>
